import React from 'react';
import { Link, Outlet, useLocation } from 'react-router-dom';
import './AdminLayout.css';
import { useRole } from '../../hooks/useRole';

const AdminLayout = () => {
    const location = useLocation();
    const { hasRole } = useRole();

    return (
        <div className="admin-layout">
            <nav className="admin-nav">
                <h2>Admin</h2>
                {hasRole('admin') && (
                <Link 
                    to="/admin/settings" 
                    className={`nav-link ${location.pathname === '/admin/settings' ? 'active' : ''}`}
                >
                    Settings
                </Link>
                )}
                {hasRole('moderator') && (
                <Link 
                    to="/admin/subscriptions" 
                    className={`nav-link ${location.pathname === '/admin/subscriptions' ? 'active' : ''}`}
                >
                    Subscriptions
                </Link>
                )}

                {hasRole('moderator') && (
                <Link 
                    to="/admin/create-invoice" 
                    className={`nav-link ${location.pathname === '/admin/create-invoice' ? 'active' : ''}`}
                >
                    Create Invoice
                </Link>
                )}

                {hasRole('moderator') && (
                <Link 
                    to="/admin/markups" 
                    className={`nav-link ${location.pathname === '/admin/markups' ? 'active' : ''}`}
                >
                    Markups
                </Link>
                )}
            </nav>
            <div className="admin-content">
                <Outlet />
            </div>
        </div>
    );
};

export default AdminLayout; 